module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921001149_T.70978342.jpg";